module.exports = __webpack_public_path__ + "media/images/credit-card-logo/visa-f87e534529f32d1ad45a32d91c9fd93a.svg";